module.exports = __webpack_public_path__ + "def2e805.svg";